// extracted by mini-css-extract-plugin
export var activeDot = "_56-c";
export var buttonContainer = "_56-9";
export var channelButton = "_56-a";
export var clickable = "_56-d";
export var content = "_56-0";
export var contentFull = "_56-2";
export var contentThird = "_56-1";
export var contentWrapper = "_56-7";
export var description = "_56-5";
export var heightShort = "_56-f";
export var image = "_56-3";
export var imageContainer = "_56-4";
export var selectButton = "_56-e";
export var spinnerContainer = "_56-b";
export var titleContent = "_56-8";
export var titleWrapper = "_56-6";